module.exports = __webpack_public_path__ + "static/media/add-friend.0c978cb0.svg";